module.exports = __webpack_public_path__ + "media/components/Insulation/QuietZoneCalculator/icons/bear-139a2d49a0bc3764c89afd19fa0f07ac.svg";